import { FC } from "react"
import OsLayout from "./OsLayout"

export const OsHomePage: FC = () => {
  return <OsLayout selectedMenuItemLabelKey="iamModule">hello private</OsLayout>
}

export default OsHomePage
